var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNarwhalLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 356.67 196.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Narwhal"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.54,57.63l-4.63-43.81-27.79-5.56,27.87,50.46-18.34,51.19L223.84,17.74l-1.9-1.79-16.08-12.71-10.8,.12-55,12.16c8.43,1.39,14.42,9.34,14.42,19.43,0,12.34-8.74,23.79-19.47,25.51-.9,.14-1.81,.22-2.7,.22-1.97,0-3.9-.35-5.73-1.05l-.08-.03-.08-.03-38.95-17.34-.64,2.73v110.5l1.23,6.47,1.62,.33h0s6.08,1.24,6.08,1.24l23.01,1.29,13.93,31.53,6.77-30.37,59.68,3.36h51.48l19.49,22.4,4.36-9.93,9.93-22.63-10.45-2.09h0l20.77-15.38,13.09-80.07,48.06-30.31,.79-22.23-54.13,48.57ZM105.06,109.4c0,4.59-3.01,8.65-6.7,9.07-3.66,.41-6.61-2.93-6.61-7.45v-7.07c0-4.53,2.95-8.6,6.61-9.11,3.69-.51,6.7,2.8,6.7,7.39v7.16Zm66.89,28.93l-54.9,4.41c-.18,.01-.35,.01-.52,0-2.49,0-4.45-2.35-4.45-5.42s2.13-5.99,4.77-6.24l54.9-5.13c.21-.02,.41-.02,.61-.01,2.81-.02,5.03,2.45,5.03,5.72,0,3.44-2.44,6.42-5.44,6.66Zm32.25-41.1c0,4.91-3.62,9.28-8.04,9.75-4.38,.47-7.91-3.07-7.91-7.91v-7.74c0-4.83,3.53-9.22,7.91-9.8,4.42-.59,8.04,2.92,8.04,7.83v7.87Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Horn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.31,57.68c.73,0,1.47-.06,2.22-.18,9.29-1.49,16.95-11.6,16.95-22.55,0-9.32-5.56-15.98-12.93-16.61L0,0,127.64,56.83c1.45,.55,3.02,.85,4.67,.85Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNarwhalLogo);
export default __webpack_public_path__ + "static/media/narwhal-logo.7c17d49d8c1e4a76c64d98239d02b08c.svg";
export { ForwardRef as ReactComponent };